import mapBoxGl from 'mapbox-gl'

const mbCtr = {
  initmap: function (e) {
    let that = this
    mapBoxGl.accessToken = 'pk.eyJ1IjoibGl1YmluMDYyMGJiIiwiYSI6ImNrczZzdGF6dzBoeG4yb2xoMTVqYnhxdHQifQ.jeDLlOyKfndZBSO0yLv8Yw'
    this.map = new mapBoxGl.Map({
      container: e,
      style: 'mapbox://styles/mapbox/satellite-v9',
      // style: 'mapbox://styles/mapbox/streets-v11',
      center: [123.48935275407804, 41.700872417060076],
      zoom: 19
    })
    this.map.on('load', function () {
      // 犯我中华者，虽远必诛
      let adminLayers = ['admin-0-boundary', 'admin-1-boundary', 'admin-0-boundary-disputed',
        'admin-1-boundary-bg', 'admin-0-boundary-bg']
      adminLayers.forEach(function (adminLayer) {
        that.map.setFilter(adminLayer, ['match', ['get', 'worldview'], ['all', 'CN'], true, false])
      })
    })
  }
}
export default mbCtr



// WEBPACK FOOTER //
// ./src/javascript/MapBox/Controller.js